export default __webpack_public_path__ + "static/media/ri_rgate.a8537049.svg";